var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-services"},[_c('div',{staticClass:"image"},[_c('img',{staticClass:"img",attrs:{"src":_vm.service.primaryImage.url,"alt":_vm.service.title + ' image'}})]),_c('p',[_vm._v(" "+_vm._s(_vm.service.title)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }